<template>
    <a :class="classes" @click="handleClick" :href="to" :target="target">
        <slot></slot>
    </a>
</template>
<script>
    import theme from './link.scss'

    export default {
        name: 'link',
        props: {
            size: {
                type: String,
                default: 'text',
            },
            target: String,
            to: String,
            disabled: Boolean,
            pointer: Boolean,
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            }
        },
        computed: {
            classes() {
                return {
                    [this.theme.link]: true,
                    [this.theme['is-' + this.size]]: true,
                    [this.theme.isDisabled]: this.disabled,
                    [this.theme.isPointer]: this.pointer,
                }
            }
        },
        methods: {
            handleClick(e) {
                if (this.disabled) {
                    return;
                }

                this.$emit('click', e);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Link.vue?efdc9c2c